// Golden Spiral Logo - Inspired by Leonardo da Vinci's studies of the Fibonacci sequence
// The spiral represents the perfect mathematical beauty found in nature

export default function GoldenSpiral({ className = "w-5 h-5", color = "currentColor" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Golden Spiral - approximated with arcs following Fibonacci proportions */}
      <path
        d="M12 2
           A10 10 0 0 1 22 12
           A8 8 0 0 1 14 20
           A5 5 0 0 1 9 15
           A3 3 0 0 1 12 12
           A2 2 0 0 1 14 14
           A1 1 0 0 1 13 15"
        fill="none"
      />
      {/* Small dot at the center - the origin point */}
      <circle cx="13" cy="14.5" r="0.5" fill={color} stroke="none" />
    </svg>
  );
}
